"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterGroupToJSON = exports.FilterGroupFromJSONTyped = exports.FilterGroupFromJSON = exports.instanceOfFilterGroup = void 0;
var runtime_1 = require("../runtime");
var FilterCriteriaType_1 = require("./FilterCriteriaType");
var FilterGroupType_1 = require("./FilterGroupType");
var FilterSearch_1 = require("./FilterSearch");
/**
 * Check if a given object implements the FilterGroup interface.
 */
function instanceOfFilterGroup(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfFilterGroup = instanceOfFilterGroup;
function FilterGroupFromJSON(json) {
    return FilterGroupFromJSONTyped(json, false);
}
exports.FilterGroupFromJSON = FilterGroupFromJSON;
function FilterGroupFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'c': !(0, runtime_1.exists)(json, 'c') ? undefined : (0, FilterCriteriaType_1.FilterCriteriaTypeFromJSON)(json['c']),
        't': !(0, runtime_1.exists)(json, 't') ? undefined : (0, FilterGroupType_1.FilterGroupTypeFromJSON)(json['t']),
        'f': !(0, runtime_1.exists)(json, 'f') ? undefined : (json['f'] === null ? null : json['f'].map(FilterSearch_1.FilterSearchFromJSON)),
    };
}
exports.FilterGroupFromJSONTyped = FilterGroupFromJSONTyped;
function FilterGroupToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'c': (0, FilterCriteriaType_1.FilterCriteriaTypeToJSON)(value.c),
        't': (0, FilterGroupType_1.FilterGroupTypeToJSON)(value.t),
        'f': value.f === undefined ? undefined : (value.f === null ? null : value.f.map(FilterSearch_1.FilterSearchToJSON)),
    };
}
exports.FilterGroupToJSON = FilterGroupToJSON;
